import type { IHttpClient } from "@/core/interfaces";
import type { IHomeGateway } from "@/modules/home";

import { AxiosHttpClient } from "@/core/http-client";
import { HOME_GATEWAY, MockHomeGateway } from "@/modules/home";
import { Registry } from "./registry";

/**
 * Registra todas as dependências da aplicação no container.
 *
 * ORDEM IMPORTA — dependências consumidas por outras devem
 * ser registradas ANTES dos seus consumidores.
 *
 * 1. HttpClient (sem dependências)
 * 2. ... gateways de domínio (dependem de HttpClient)
 *
 * Cada registro é verificado isoladamente para que uma dependência já provida
 * (por um teste, por exemplo) não impeça o registro das demais.
 */
export function initializeDependencies(): void {
  const registry = Registry.getInstance();

  if (!registry.has("HttpClient")) {
    registry.provide<IHttpClient>("HttpClient", new AxiosHttpClient());
  }

  // A Tela Inicial consome o arquivo de mock local nesta entrega (US-1614):
  // habilitar os dados reais é trocar esta implementação pela versão HTTP, sem
  // alterar a tela, o hook ou os componentes de apresentação.
  if (!registry.has(HOME_GATEWAY)) {
    registry.provide<IHomeGateway>(HOME_GATEWAY, new MockHomeGateway());
  }
}
